// extracted by mini-css-extract-plugin
export default {"list":"UploadHistory_list__4quQA","statusIcon":"UploadHistory_statusIcon__uRoxl","pdf":"UploadHistory_pdf__Bd-Es","image":"UploadHistory_image__fgxM1"};